// For local dev, look for local files
const jsonURL = 'https://labreports.uvic.ca/maps/std'
const icsURL = 'https://web.uvic.ca/~chdfiles/public'
let hours = {}
let rooms = []

async function locationHours() {
	// Fetch the data
	const res = await fetch(`${jsonURL}/avail.json?noredir=1`)
	
	// Data didn't load, bail
	if (!res.ok) {
		console.error(`${res.status} - ${res.statusText}`)
		return
	}

	// Grab the data
	const data = await res.text()
	const dataObj = JSON.parse(data)
	// console.log(dataObj);
	hours = dataObj.results.states
	rooms = dataObj.results.divs
	// console.log(hours);
	// console.log(rooms);

	// Find all the locations
	const locs = document.querySelectorAll('.loc')
	locs.forEach((loc) => {
		// Get the room to check
		const room = loc.dataset.loc
		// console.log(room);

		// if there's no room, skip to the next element
		if (!room) {
			return
		}

		// Set closed/open status message
		const isOpen = hours[room].state
		const changeMsg = isOpen ? 'Open until' : 'Opens at'
		const roomMsg = isOpen ? 'Open' : 'Closed'

		// Generate date object from current time versus seconds until location closed/open status changes
		const changeDate = new Date()
		changeDate.setSeconds(changeDate.getSeconds() + hours[room].boundary)

		// Round minutes to nearest half-hour
		// TEMP: Adjust time
		// changeDate.setMinutes(changeDate.getMinutes() + 5)
		// Get minutes rounded to 30 minute increments
		let changeMins = Math.round(changeDate.getMinutes()/30)*30
		// console.log(changeMins);
		// Set minutes to rounded time
		changeDate.setMinutes(changeMins)
		
		// Set people readable time for status change
		const changeTime = changeDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

		// Output status change message
		const locTime = loc.querySelector('.loc__time')
		if (locTime) {
			locTime.innerHTML = `${changeMsg} ${changeTime}`
		}

		// Set status message for each room in location
		const rooms = loc.querySelectorAll('.loc__room')
		rooms.forEach((room) => {
			room.innerHTML = roomMsg
			if (isOpen) {
				room.classList.add('loc__room--open')
				room.dataset.tag = 'Available'
			} else  {
				room.dataset.tag = 'Closed'
			}
		})
	})

	if (document.querySelector('.loc__room--open')) {		
		roomState()
	}
}
locationHours()

async function roomState() {
	// Find all the open bookable rooms that are open
	const bookable = document.querySelectorAll('.loc__room--bookable.loc__room--open[data-calid]')
	// console.log(bookable);

	// Check bookable rooms are booked or not
	for ( const room of bookable) {
		// Get calendar name
		const calID = room.dataset.calid
		// console.log(calID);
		
		// Fetch calendar data
		const res = await fetch(`${icsURL}/${calID}`)	

		// Data didn't load, bail
		if (!res.ok) {
			console.error(`${res.status} - ${res.statusText}`)
		} else {
			// parse data 
			const data = await res.text()
			// Uses ical.min.js from https://github.com/mozilla-comm/ical.js/
			const jCalData = ICAL.parse(data)
			// console.log(jCalData)
			
			// process data
			const jCalComp = new ICAL.Component(jCalData)
			const jCalVEvents = jCalComp.getAllSubcomponents("vevent")
			// console.log(jCalVEvents);

			// Check if room is occupied right now
			const now = new Date()
			for (const jCalVEvent of jCalVEvents) {
				const jCalEvent = new ICAL.Event(jCalVEvent)
				// console.log(jCalEvent);

				const start = new Date(jCalEvent.startDate.toJSDate())
				const end = new Date(jCalEvent.endDate.toJSDate())
				// console.log(start);

				// Event right now: has started, hasn't ended
				if (now > start && now < end) {
					// console.log(end);

					// Set status to 'Occupied' and remove open class
					room.innerHTML = 'Occupied'
					room.dataset.tag = 'Closed'
					room.classList.remove('loc__room--open')
				}
			}			
		}
	}

	// Find all remaining open, drop-in rooms
	const dropins = document.querySelectorAll('.loc__room--dropin.loc__room--open')

	// Check drop-in rooms for open computers
	for ( const room of dropins) {
		// Get room ID
		const roomID = room.dataset.roomid
		// console.log(roomID);

		// if there's no room, skip to the next element
		if (!roomID) {
			return
		}
		
		// Find data in rooms array
		const roomData = rooms.find(r => r.name === roomID)
		// console.log(roomData);

		// Number of occupied computer from total
		const openComps = roomData.total - roomData.active
		// console.log(openComps);
		
		// Output total number of available computers
		room.innerHTML = openComps
		if (openComps == 0) {				
			room.dataset.tag = 'Closed'
			room.classList.remove('loc__room--open')
		}
	}
}